module.exports = __webpack_public_path__ + "static/media/store1.83a4b48a.png";